<div class="row mt--32">
  <div class="col-12">
    <div class="d-flex flex-column">
      <div class="d-flex flex-row justify-content-between">
        <h3>{{ 'pages.transport.tracking-overview.widgets.key-indicators.title' | translate }}</h3>
        <span class="btn btn-link cursor-default">{{
          'pages.transport.tracking-overview.widgets.key-indicators.date-range' | translate
        }}</span>
      </div>

      @if (isLoading()) {
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4 mb--16">
            <p-skeleton width="100%" height="160px" />
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb--16">
            <p-skeleton width="100%" height="160px" />
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb--16">
            <p-skeleton width="100%" height="160px" />
          </div>
        </div>
      }

      @if (isSuccess()) {
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4 mb--16">
            <transport-history-kpi-card [kpiData]="totalKpiCardData()" />
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb--16">
            <transport-history-kpi-card [kpiData]="issueKpiCardData()" />
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb--16">
            <transport-history-kpi-card [kpiData]="delayedKpiCardData()" />
          </div>
        </div>
      }

      @if (isOnError()) {
        <p-message severity="error">
          <span class="bold" [innerHTML]="errorMessage().title"> </span>
          <span [innerHTML]="errorMessage().description"> </span>
        </p-message>
      }
    </div>
  </div>
</div>
